import { render, staticRenderFns } from "./AppointmentInformation.vue?vue&type=template&id=2ace9755&scoped=true"
import script from "./AppointmentInformation.vue?vue&type=script&lang=js"
export * from "./AppointmentInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ace9755",
  null
  
)

export default component.exports